export enum MutationTypes {
    SET_EMPLOYEES_LIST = "setEmployeesList",
    SET_EMPLOYEES_DATA_IS_LOADING = "setEmployeesDataIsLoading",
    SET_EMPLOYEES_FILTER_VALUE = "setEmployeesFilterValue",
    SET_EMPLOYEES_SELECTED_EMPLOYEE = "setEmployeesSelectedEmployee",
    SET_EMPLOYEES_ERROR_MESSAGE = "setEmployeesErrorMessage",
}